import React, { createContext, useContext, useState, useEffect } from "react";

const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
  const [domainId, setDomainId] = useState(() => sessionStorage.getItem("domainId"));
  const [source, setSource] = useState(() => sessionStorage.getItem("source"));

  useEffect(() => {
    if (domainId) {
      sessionStorage.setItem("domainId", domainId);
    }
    if (source) {
      sessionStorage.setItem("source", source);
    }
  }, [domainId, source]);

  return (
    <DomainContext.Provider value={{ domainId, setDomainId, source, setSource }}>
      {children}
    </DomainContext.Provider>
  );
};

export const useDomain = () => useContext(DomainContext);
